import { action, atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export const selectedPoizonClientAtom = atom(
  -1,
  "selectedPoizonClientAtom",
).pipe(withLocalStorage("selectedPoizonClient"));

export const selectPoizonClientAction = action((ctx, clientId: number) => {
  selectedPoizonClientAtom(ctx, clientId);
});
